const liveOn = false;

export { liveOn };
